import React, { Component } from 'react';
import { Modal, Button, Form, TextArea, Radio, Icon } from 'semantic-ui-react';
import SaveButtonWithTooltip from '../SaveButtonWithTooltip';
import { updateInPath } from '../../../../common/utils';
import { withNamespaces } from 'react-i18next';
import { clone } from 'ramda';


class MutationModal extends Component {
  constructor(props) {
    super(props);

    this.state = { data: clone(props.data) };
  }

  handleSave = () => {
    this.props.onSave(this.state.data);
  };

  handleChange = (e, {name, value}) => {
    this.setState(s => updateInPath(s, 'data.' + name, value));
  };

  handleToggle = (e, {name, checked}) => {
    this.setState(s => updateInPath(s, 'data.' + name, checked));
  };

  handleTrue = (e, {name, checked}) => {
    this.setState(s => updateInPath(s, 'data.' + name, true));
    };

  handleFalse = (e, {name, checked}) => {
    this.setState(s => updateInPath(s, 'data.' + name, false));
  };
  
  render() {
    // TODO this ...Ok part is not elegant
    const { t, open } = this.props,
          { present, status, comments } = this.state.data;

    return (
      <Modal open={open}>
        <Modal.Header content={t('private:technicalControl.header')} />
        <Modal.Content>
          <Form>
            <Form.Field>
              {t('private:technicalControl.present')}
            </Form.Field>
            <Form.Group widths='equal'>
              <Form.Field>
                <Radio
                  name='present'
                  label='Y'
                  checked={present ===  true}
                  onChange={this.handleTrue}
                /> - 
                <Icon color='grey' name='check' />
              </Form.Field>
              <Form.Field>
                <Radio
                  name='present'
                  label='N'
                  checked={present !== true}
                  onChange={this.handleFalse}
                /> - 
                <Icon color='green' name='minus' />
              </Form.Field>
            </Form.Group>
            <Form.Field>
             {t('private:technicalControl.result')}
            </Form.Field>
            <Form.Group widths='equal'>
              <Form.Field>
                <Radio
                  name='status'
                  label={t('private:technicalControl.status.NA')}
                  value='NA'
                  checked={status === 'NA'}
                  onChange={this.handleChange}
                /> - 
                <Icon color='grey' name='minus' />
              </Form.Field>
              <Form.Field>
                <Radio
                  name='status'
                  label={t('private:technicalControl.status.PASSED')}
                  value='PASSED'
                  checked={status === 'PASSED'}
                  onChange={this.handleChange}
                /> - 
                <Icon color='green' name='check' />
              </Form.Field>
              <Form.Field>
                <Radio
                  name='status'
                  label={t('private:technicalControl.status.FAILED')}
                  value='FAILED'
                  checked={status === 'FAILED'}
                  onChange={this.handleChange}
                /> - 
                <Icon color='red' name='ban' />
              </Form.Field>
            </Form.Group>
            <Form.Field
              width={16}
              required
              control={TextArea}
              label={t('private:technicalControl.comments')}
              placeholder={t('private:technicalControl.comments_i')}
              name='comments'
              value={comments}
              onChange={this.handleChange}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button
            content={t('common:cancel')}
            onClick={this.props.onClose}
          />
          <SaveButtonWithTooltip
            enabled={true}
            tooltip={[]}
            onSave={this.handleSave}/>
        </Modal.Actions>
      </Modal>
    );
  };
};

export default withNamespaces(['private', 'common'])(MutationModal);



// WEBPACK FOOTER //
// ./src/private/common/components/TechnicalControl/index.js